import type { Edge, Node } from "@xyflow/react";
import type { StoreApi } from "zustand";

import type { WorkflowEditorStore } from "@/modules/workflow/stores/workflow-editor-store-types.ts";
import type { EdgeData, EditorNodeData, WorkflowParameter } from "@/modules/workflow/utils/types.ts";
import { MAX_UNDO_TIMELINE_LENGTH } from "@/settings/undo-redo-settings.ts";

export const pushTimelineData = (
  set: StoreApi<WorkflowEditorStore>["setState"],
  get: StoreApi<WorkflowEditorStore>["getState"],
  nodes: Node<EditorNodeData>[],
  edges: Edge<EdgeData>[],
  parameters: WorkflowParameter[],
) => {
  const timeline = [...get().timeline];
  const newTimeline = timeline.slice(0, get().timelineIndex + 1);
  newTimeline.slice(-1)[0].parameters = parameters;
  newTimeline.push({ nodes: nodes, edges: edges, parameters: [] });
  if (newTimeline.length > MAX_UNDO_TIMELINE_LENGTH + 1) {
    newTimeline.shift();
  }
  const newTimelineIndex = newTimeline.length - 1;

  set({
    timeline: newTimeline,
    timelineIndex: newTimelineIndex,
    canUndo: newTimelineIndex > 0,
    canRedo: false,
  });
};
